// resources/js/portrait-video.js

import Hls from 'hls.js';

export default ({ videoId, customerCode, previewSeconds = 3 }) => ({
    videoId,
    customerCode,
    previewSeconds,

    hls: null,

    initialized: false,
    ready: false,
    inViewport: false,

    previewMode: true,
    muted: true,

    enterViewport() {
        this.inViewport = true;

        if (!this.initialized) {
            this.initVideo();
            return;
        }

        if (this.ready && this.previewMode) {
            this.$refs.video.play().catch(() => {
            });
        }
    },

    leaveViewport() {
        this.inViewport = false;

        if (this.previewMode) {
            this.$refs.video.pause();
        }
    },

    initVideo() {
        if (this.initialized) {
            return;
        }

        this.initialized = true;

        const video = this.$refs.video;

        const src =
            `https://customer-${this.customerCode}.cloudflarestream.com/` +
            `${this.videoId}/manifest/video.m3u8`;

        video.muted = true;

        // Safari / iOS
        if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = src;

            video.addEventListener(
                'loadedmetadata',
                () => {
                    this.ready = true;

                    if (this.inViewport && this.previewMode) {
                        video.play().catch(() => {
                        });
                    }
                },
                { once: true }
            );

            return;
        }

        // Chrome / Firefox / Edge
        if (Hls.isSupported()) {
            this.hls = new Hls();

            this.hls.attachMedia(video);

            this.hls.on(Hls.Events.MEDIA_ATTACHED, () => {
                this.hls.loadSource(src);
            });

            this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                this.ready = true;

                if (this.inViewport && this.previewMode) {
                    video.play().catch(() => {
                    });
                }
            });
        }
    },

    handlePreviewLoop() {
        if (!this.previewMode) {
            return;
        }

        const video = this.$refs.video;

        if (video.currentTime >= this.previewSeconds) {
            video.currentTime = 0;

            if (this.inViewport) {
                video.play().catch(() => {
                });
            }
        }
    },

    handleTimeUpdate() {
        if (!this.previewMode) {
            return;
        }

        const video = this.$refs.video;

        if (video.currentTime >= this.previewSeconds) {
            video.currentTime = 0;

            if (this.inViewport) {
                video.play().catch(() => {
                });
            }
        }
    },

    async handleVideoClick() {
        const video = this.$refs.video;

        // First click: exit preview mode and start full video
        if (this.previewMode) {
            if (!this.initialized) {
                this.initVideo();
            }

            this.previewMode = false;

            video.currentTime = 0;
            video.muted = false;
            this.muted = video.muted;

            try {
                await video.play();
            } catch (error) {
                console.error('Unable to play video:', error);
            }

            return;
        }

        // Subsequent clicks: toggle play / pause
        if (video.paused) {
            try {
                await video.play();
            } catch (error) {
                console.error('Unable to play video:', error);
            }
        } else {
            video.pause();
        }
    },

    handleEnded() {
        const video = this.$refs.video;

        this.previewMode = true;

        video.muted = true;
        this.muted = video.muted;

        video.currentTime = 0;

        if (this.inViewport) {
            video.play().catch(() => {
            });
        }
    },

    toggleMute() {
        const video = this.$refs.video;
        video.muted = !video.muted;

        // Read the actual resulting state from the video.
        this.muted = video.muted;
    },

    syncMuted() {
        this.muted = this.$refs.video.muted;
    },

    destroy() {
        this.hls?.destroy();
        this.hls = null;
    }
});
